import { motion } from "framer-motion";
import { useEffect, useState } from "react";
interface PartnershipCardProps {
  title: string;
  subtitle: string;
  playerImages: string[];
  logo: string;
  delay?: number;
  skipInitialAnimation?: boolean;
}
const PartnershipCard = ({
  title,
  subtitle,
  playerImages,
  logo,
  delay = 0,
  skipInitialAnimation = false
}: PartnershipCardProps) => {
  const [processedImages, setProcessedImages] = useState<string[]>(playerImages);
  return <motion.div initial={skipInitialAnimation ? { opacity: 1, y: 0 } : {
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{ once: true }} transition={{
    duration: skipInitialAnimation ? 0 : 0.6,
    delay: skipInitialAnimation ? 0 : delay
  }} className="bg-[#0E0F14] border border-white rounded-lg p-6 md:p-8 lg:p-10 relative overflow-visible flex flex-col lg:flex-row items-center lg:items-center justify-between gap-6 md:gap-8 shadow-[0_8px_30px_rgba(0,0,0,0.3)]">
      {/* Text Content */}
      <div className="relative z-10 flex-1 text-center lg:text-left space-y-4 md:space-y-6">
        <div>
          <h2 className="text-white text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-3">
            {title}
          </h2>
        </div>
        <div className="flex justify-center lg:justify-start">
          <img src={logo} alt={`${title} logo`} width={96} height={96} loading="lazy" decoding="async" className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 object-contain" />
        </div>
      </div>

      {/* Player Images - Overlapping Staggered Formation */}
      <div className="relative flex items-end justify-center lg:justify-end h-[180px] sm:h-[220px] md:h-[280px] lg:h-[320px] -mt-6 -mb-6 md:-mt-10 md:-mb-10">
        {/* Left Player - Behind */}
        <div className="relative z-10 transform translate-x-4 sm:translate-x-6 md:translate-x-12">
          <img src={processedImages[0]} alt="Player 1" width={200} height={320} loading="lazy" decoding="async" className="h-[180px] sm:h-[220px] md:h-[280px] lg:h-[320px] w-auto object-contain drop-shadow-[0_10px_25px_rgba(0,0,0,0.5)] filter brightness-95" />
        </div>

        {/* Center Player - Front (Biggest) */}
        <div className="relative z-20">
          <img src={processedImages[1]} alt="Player 2" width={200} height={320} fetchPriority="high" className="h-[180px] sm:h-[220px] md:h-[280px] lg:h-[320px] w-auto object-contain drop-shadow-[0_15px_35px_rgba(0,0,0,0.6)]" />
        </div>

        {/* Right Player - Behind */}
        <div className="relative z-10 transform -translate-x-4 sm:-translate-x-6 md:-translate-x-12">
          <img src={processedImages[2]} alt="Player 3" width={200} height={320} loading="lazy" decoding="async" className="h-[180px] sm:h-[220px] md:h-[280px] lg:h-[320px] w-auto object-contain drop-shadow-[0_10px_25px_rgba(0,0,0,0.5)] filter brightness-95" />
        </div>
      </div>
    </motion.div>;
};
export default PartnershipCard;